/* tslint:disable:indent */
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import * as jsonLang from '../../../assets/config/lang.json';
import * as jsonMenu from '../../../assets/config/menu.json';
import { AuthSessionServiceDelegate } from '../../authentication/services/delegate.auth.session.service';
import { AuthorizationService } from '../../authorization/services/authorization.service';
import { EnumMicroDroits } from '../../modules/administration/models/micro.droits';
import { PreferencesService } from './../../modules/avisDePub/preferences-avis-de-pub/services/preferences.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  public currentLanguage;
  public navItems = jsonMenu.navItems;
  public hamburgerItems = jsonMenu.hamburgerItems;
  public transLang = jsonLang.choice_language;
  public mapLang = new Map<any, any>();

  displayPreference: boolean = false;
  displayProfil: Observable<boolean>;
  isCreateAvailable: Observable<boolean>;
  isListAvailable: Observable<boolean>;
  isPreferenceAvailable: Observable<boolean>;

  constructor(public translate: TranslateService, private preferencesService: PreferencesService,
    private authSession: AuthSessionServiceDelegate, private authorizationService: AuthorizationService) {
  }


  public ngOnInit() {
    this.mapLang = new Map([
      ['Français', 'fr'],
      ['French', 'fr'],
      ['Anglais', 'en'],
      ['English', 'en'],
    ]);

    this.displayPreference = this.preferencesService.displayPreference();
    if (navigator.language == 'fr-FR') {
      this.currentLanguage = 'Français';
    }

    this.displayProfil = this.authSession.isSwitchable();

    this.habilitations();

  }

  redirect(id) {
    switch (id) {
      case 0:
        //this.router.navigate(['/signer']);
        break;
      case 1:
        //this.router.navigate(['/signer']);
        break;
      case 2:
        //this.router.navigate(['/verifier/process']);
        break;
    }
  }

  public closeMenu() {
    if (document.getElementById('sidenav-mobile') != null) {
      document.getElementById('sidenav-mobile').style.width = '0';
    }
    if (document.getElementById('opacity') != null) {
      document.getElementById('opacity').style.display = 'none';
    }
  }

  private habilitations() {
    this.isCreateAvailable = this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.AVIS_PUBLICITE_GESTION]);
  
    this.isListAvailable = this.authorizationService.hasAnyMicroRightIn([
      EnumMicroDroits.AVIS_PUBLICITE_CONSULTATION,
      EnumMicroDroits.AVIS_PUBLICITE_GESTION
    ]);

    this.isPreferenceAvailable = this.authorizationService.hasAnyMicroRightIn([
      EnumMicroDroits.COMPTES_ANNONCEURS_GESTION,
      EnumMicroDroits.COMPTES_ANNONCEURS_CONSULTATION,
      EnumMicroDroits.DONNEES_FACTURATIONS_GESTION,
      EnumMicroDroits.DONNEES_FACTURATIONS_CONSULTATION
    ]);
  }
}
